import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "omni-Arrow-change",
  "use": "omni-Arrow-change-usage",
  "viewBox": "0 0 7 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 6\" id=\"omni-Arrow-change\"><path data-name=\"Polygon 127\" d=\"M3.5 0L7 6H0z\" fill=\"#39b3ae\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol